import React from 'react';

// A light band sweeping across a button while its action is in flight.
//
// The same `foil-band` + `foil-sweep` pair the plate AurumButton and ProBanner
// already use, extracted so the three submit buttons do not each re-roll it.
// Pairs with ButtonSpinner: the spinner is the literal statement that
// something is happening, this is the atmosphere around it.
//
// Motion-safe, unlike the spinner. This one IS decoration — under
// prefers-reduced-motion it simply does not render, and the spinner beside the
// label still carries the meaning.
//
// `onLight` picks the band strength, and it is not cosmetic. A 7% white sweep
// is right on the dark outline button and completely invisible on the metallic
// and plate chrome, which is already near-white — those need the 75% band the
// plate variant's own specular sweep uses. Getting this backwards means the
// shimmer silently does nothing, which is how the rim it replaced went unnoticed.
//
// The caller must be `relative overflow-hidden`, and its own content should sit
// on `relative z-10` so the band passes UNDER the label rather than over it.
export default function ButtonShimmer({ onLight = false, className = '' }) {
  return (
    <span
      aria-hidden="true"
      data-testid="button-shimmer"
      className={[
        'pointer-events-none absolute inset-y-0 w-[38%]',
        onLight ? 'bg-foil-band' : 'bg-foil-band-soft',
        'motion-safe:animate-[foil-sweep_1.6s_ease-in-out_infinite]',
        'motion-reduce:hidden',
        className,
      ].filter(Boolean).join(' ')}
    />
  );
}
